var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { IconRotator, TextIconSpacing } from "@react-md/icon";
import { bem } from "@react-md/utils";
var block = bem("rmd-menu-icon");
export function ToggleChildren(_a) {
    var dropdownIcon = _a.dropdownIcon, disableDropdownIcon = _a.disableDropdownIcon, children = _a.children, visible = _a.visible;
    if (disableDropdownIcon || !dropdownIcon) {
        return _jsx(_Fragment, { children: children }, void 0);
    }
    return (_jsx(TextIconSpacing, __assign({ icon: _jsx(IconRotator, __assign({ rotated: visible, className: block() }, { children: dropdownIcon }), void 0), iconAfter: true }, { children: children }), void 0));
}
//# sourceMappingURL=ToggleChildren.js.map